import { render, staticRenderFns } from "./TopAssessores.vue?vue&type=template&id=cc165fd8&scoped=true&"
import script from "./TopAssessores.vue?vue&type=script&lang=js&"
export * from "./TopAssessores.vue?vue&type=script&lang=js&"
import style0 from "./TopAssessores.vue?vue&type=style&index=0&id=cc165fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc165fd8",
  null
  
)

export default component.exports